import { Navigate, useLocation } from 'react-router-dom';
import { useAuthUser } from '../../hooks/useAuthUser';
import AppLoader from '../AppLoader/AppLoader';

const ProtectedRoute = ({ children }) => {
	const { user, isLoaded } = useAuthUser();
	const location = useLocation();

	if (!isLoaded) {
		return <AppLoader message='Checking your session...' />;
	}

	if (!user) {
		const redirectTo = encodeURIComponent(location.pathname + location.search);
		return <Navigate to={`/login?redirectTo=${redirectTo}`} replace />;
	}

	return children;
};

export default ProtectedRoute;
